var lib_core = require("lib-core");

if(typeof window !== 'undefined')
    var BrowserUtil = require("ui-extensions").BrowserUtil;

var ExportModelStateMachine = function (root, model, loadingModel, versionsSM) {
    var self = this;

    this.root = root;

    lib_core.StateMachine.call(self);

    this.model = model;
    this.loadingModel = loadingModel;
    this.versionsSM = versionsSM;
    ////////

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EXPORT_MODEL_PRESSED;
        },
        function(cEvent){
            // flip the flag
            var current = self.model.selectExportModalShown();
            self.model.selectExportModalShown(!current);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EXPORT_MODEL_CANCEL;
        },
        function(cEvent){
            // flags are meh, we need a better way to solve popups.
            self.model.selectExportModalShown(false);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EXPORT_MODEL_OBJ;
        },
        function(cEvent){
            self.model.selectExportModalShown(false);

            self.loadingModel.addLoad("Exporting", "Exporting as OBJ file.");

            self.root.data.model3d().getResource()
            .then(function(res){

                return self.root.data.model3d().getFileData("obj")
                .then(function(objData){

                    BrowserUtil.downloadData( objData, res.name+'.obj');
                    self.loadingModel.changeDetails("Exporting", "Exporting as MTL file.");
                    
                    return self.root.data.model3d().getFileData("mtl", true)
                    .then(function(mtlData){

                        self.loadingModel.removeLoad("Exporting");
                        BrowserUtil.downloadData( mtlData, res.name+'.mtl' );
                        self.model.selectExportModalShown(true);
                    })
                })
            })
            .catch(function(){
                 self.loadingModel.removeLoad("Exporting");
            });
        }
    );
    
    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EXPORT_MODEL_F3D;
        },
        function(cEvent){
            self.model.selectExportModalShown(false);

            self.loadingModel.addLoad("Exporting", "Exporting as F3D file.");

            self.root.data.model3d().getResource()
            .then(function(res){
                return self.root.data.model3d().getFileData("f3d")
                .then(function(f3dData){
                    self.loadingModel.removeLoad("Exporting");
                    BrowserUtil.downloadData( f3dData, res.name+'.f3d');
                    self.model.selectExportModalShown(true);
                })
            })
            .catch(function(){
                 self.loadingModel.removeLoad("Exporting");
            });
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EXPORT_MODEL_STEP;
        },
        function(cEvent){

            self.model.selectExportModalShown(false);
            self.loadingModel.addLoad("Exporting", "Exporting as STEP file.");

            self.root.data.model3d().getResource()
            .then(function(res){

                return self.root.data.model3d().getFileData("stp")
                .then(function(stepData){
                    self.loadingModel.removeLoad("Exporting");
                    BrowserUtil.downloadData( stepData, res.name+'.step');
                    self.model.selectExportModalShown(true);
                })
            })
            .catch(function(){
                 self.loadingModel.removeLoad("Exporting");
            });
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.MAKEVERSION_MODAL_CANCEL;
        },
        function(cEvent){
            self.model.forceVersionModalShown(false);
            self.model.selectExportModalShown(true);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EXPORT_LBR_MAKEVERSION;
        },
        function(cEvent){
            var description = "Automatically created for LBR export.";
            self.model.forceVersionModalShown(false);

            self.versionsSM.createNewVersion(description)
            .then(function(){
                self.exportLBR(self.versionsSM.model.asset().getLastVersion().version);
            })
            .catch(function(){
                 self.loadingModel.removeLoad("Exporting");
            });
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EXPORT_MODEL_LBR;
        },
        function(cEvent){

            self.model.selectExportModalShown(false);
            // if has changed since last version, and i can make version
            if(self.versionsSM && self.root.hasUnsavedChanges) {
                self.model.forceVersionModalShown(true);
            } else {
                if(self.versionsSM){
                    self.exportLBR(self.versionsSM.model.asset().getLastVersion().version);
                } else {
                    self.exportLBR(self.root.asset.getLastVersion().version);
                }
            }
        }
    );
};

lib_core.inherit(ExportModelStateMachine, lib_core.StateMachine);
module.exports = ExportModelStateMachine;

ExportModelStateMachine.prototype.exportLBR = function(version) {
    var self = this;
    self.loadingModel.addLoad("Exporting", "Exporting as LBR file.");

    self.root.dataLoader.dataManager.getEagleLibraryExport("package", self.root.asset.id, version)
    .then(function(lbrData){
        BrowserUtil.downloadData((new XMLSerializer()).serializeToString(lbrData.documentElement) , self.root.data.metaData().name() + '.lbr');
        self.loadingModel.removeLoad("Exporting");
        self.model.selectExportModalShown(true);
    })
    .catch(function(error){
        self.loadingModel.removeLoad("Exporting");
    });
}




